import { type Event, type SelectionParams } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Reads the product from events its customization machine sends, or that
 * XState raises when that machine crashes. Both carry the machine's id, which
 * is the selection id it was spawned with.
 */
export function getActorSelectionParams(args: ActorEventArgs): SelectionParams {
  return { selectionId: args.event.actorId };
}

/**
 * Reads the product whose add missed its deadline.
 */
export function getTimedOutSelectionParams(args: TimedOutEventArgs): SelectionParams {
  return { selectionId: args.event.selectionId };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type ActorEventArgs = {
  event: { actorId: string };
};

type TimedOutEventArgs = {
  event: Extract<Event, { type: 'PRODUCT_TIMED_OUT' }>;
};
